import { makeAutoObservable } from "mobx"

interface Modal {
    open: boolean;
    body: JSX.Element | null;
    size: "mini" | "small" | "tiny" | "large" | "fullscreen" | undefined;
}

export default class ModalStore {
    modal: Modal = {
        open: false,
        body: null,
        size: 'mini'
    }

    constructor() {
        makeAutoObservable(this)
    }

    openModal = (content: JSX.Element) => {
        this.modal.open = true;
        this.modal.body = content;
        this.modal.size = 'mini';
    }

    openModalWithSize = (content: JSX.Element, modalSize: "mini" | "small" | "tiny" | "large" | "fullscreen" | undefined) => {
        this.modal.open = true;
        this.modal.body = content;
        this.modal.size = modalSize;
    }

    closeModal = () => {
        this.modal.open = false;
        this.modal.body = null;
        this.modal.size = 'mini';
    }
}